import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { Heading } from '../components';
import { PrimaryButton, PrimaryOutlineButton } from '../buttons';
import { LeadFormContainer, ButtonContainer } from './';

const SuccessMessage = ({ onRequestClose, showPdfSucces, formalLanguage }) => (
  <LeadFormContainer>
    <Heading>
      <strong>Bedankt! </strong>
      {showPdfSucces
        ? 'Het persoonlijk rapport is nu gedownload'
        : `Er wordt zo snel mogelijk contact met ${formalLanguage ? 'u' : 'je'} opgenomen`
      }
    </Heading>
    <p>Nieuwe berekening maken? Klik op de onderstaande knop om een nieuwe berekening te maken</p>
    <ButtonContainer
      css={css`
        margin-top: 24px;
      `}
    >
      <PrimaryOutlineButton onClick={() => onRequestClose()}>Sluiten</PrimaryOutlineButton>
      <PrimaryButton onClick={() => window.location.reload()}>Nieuwe berekening maken</PrimaryButton>
    </ButtonContainer>
  </LeadFormContainer>
);

SuccessMessage.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  showPdfSucces: PropTypes.bool,
  formalLanguage: PropTypes.bool,
};

SuccessMessage.defaultProps = {
  showPdfSucces: false,
  formalLanguage: false,
}

export default SuccessMessage;
